/**
 * This file contains authentication parameters. Contents of this file
 * is roughly the same across other MSAL.js libraries. These parameters
 * are used to initialize Angular and MSAL Angular configurations in
 * in app.module.ts file.
 */

import {
  LogLevel,
  Configuration,
  BrowserCacheLocation,
} from '@azure/msal-browser';

const isIE =
  window.navigator.userAgent.indexOf('MSIE ') > -1 ||
  window.navigator.userAgent.indexOf('Trident/') > -1;

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
export const msalConfig: Configuration = {
  auth: {
    //My Auth keys following
    //   clientId: '00e8ce56-d560-4ce8-aa2b-68c0fd3e96a5', // This is the ONLY mandatory field that you need to supply.
    //   authority: 'https://login.microsoftonline.com/10eed52a-2e80-459a-9429-e971fa1da743', // Defaults to "https://login.microsoftonline.com/common"
    //   redirectUri: 'https://localhost:44321/login', // Points to window.location.origin. You must register this URI on Azure portal/App Registration.
    // navigateToLoginRequestUrl: true,

    //ClientAuthkeys following
    clientId: 'fbc17e79-f41f-4436-8db9-e5b7bd8e0eef',
    redirectUri:'https://pkffarmer-prod.azurewebsites.net/signin-oidc',
    //redirectUri: 'https://appdev01.maricoapps.biz/pkf',
    //redirectUri: 'https://pkffarmer-dev1.azurewebsites.net/signin-oidc',
    //redirectUri: 'https://localhost:44321/signin-oidc',
    //postLogoutRedirectUri: 'http://localhost:4200',

    authority:
      'https://login.microsoftonline.com/5635d8b8-c9b9-4d9a-8a4d-f7cad74dc82a',
    navigateToLoginRequestUrl: true,

    //BE Authkeys following givenby backend team
    //  clientId: 'd1115746-b0f4-4d6d-84df-f036cb81d4be',
    //  redirectUri: 'https://localhost:44321/signin-oidc',
    //  authority: 'https://login.microsoftonline.com/10eed52a-2e80-459a-9429-e971fa1da743',

    //postLogoutRedirectUri: '/login', // Indicates the page to navigate after logout.
    //navigateToLoginRequestUrl: true, // If "true", will navigate back to the original request location before processing the auth code response.
  },
  cache: {
    cacheLocation: BrowserCacheLocation.LocalStorage, // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
    storeAuthStateInCookie: isIE, // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    loggerOptions: {
      loggerCallback(logLevel: LogLevel, message: string) {},
      logLevel: LogLevel.Verbose,
      piiLoggingEnabled: false,
    },
  },
};

/**
 * An optional silentRequest object can be used to achieve silent SSO
 * between applications by providing a "login_hint" property.
 */
export const silentRequest = {
  scopes: ['openid', 'profile'],
  loginHint: 'example@domain.net',
};
